import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {OverlayService} from "../../overlay/overlay.service";
import {GallerySliderComponent} from "../gallery-slider/gallery-slider.component";
import {YoutubeVideoOverlayComponent} from "../youtube-video-overlay/youtube-video-overlay.component";
import {GalleryData} from "../gallery-preview/gallery-data";
import {GalleryItemData} from "../gallery-preview/gallery-item-data";
import {DisplayService} from "../../services/display.service";

@Component({
  selector: 'brt-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements Overlayable, AfterViewInit {

  @ViewChild("dialogElement") dialogElement!: ElementRef<HTMLDialogElement>;
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input("data") set setData(val: GalleryData) {
    this.data = val;

    const items: GalleryItemData[] = JSON.parse(JSON.stringify(val.items ?? []));

    // const videos: GalleryItemData[] = items.filter((el) => el.type === "video");
    // const images: GalleryItemData[] = items.filter((el) => el.type === "image");

    // this.columns[0].push(images.shift() ?? images[0]);

    const hasVideos = items.some((el) => el.type === "video");
    const hasImages = items.some((el) => el.type === "image");

    let counter = 0;

    while(items.length) {
      let nextItem: GalleryItemData | undefined = undefined;

      const nextCol = counter % 2;
      nextItem = items.shift();

      if(nextItem) {
        this.columns[nextCol].push(nextItem);
      }
      counter++;
    }

    this.filterHidden = !hasVideos || !hasImages;

    this.setFilter(this.currentFilter);
  };

  filterMods = [{key: "all", label: "Alle"}, {key: "image", label: "Bilder"}, {key: "video", label: "Videos"}];

  filterHidden = false;
  currentFilter = this.filterMods[0].key;

  columns: GalleryItemData[][] = [new Array(0), new Array(0)];
  filteredColumns: GalleryItemData[][] = [];

  data!: GalleryData;

  constructor(private overlay: OverlayService, private displayService: DisplayService) {
  }

  ngAfterViewInit() {
    if(this.dialogElement.nativeElement) {
      this.dialogElement.nativeElement.showModal();
    }
  }

  setFilter(key: string) {
    this.currentFilter = key;

    this.filteredColumns = [];
    // console.log(this.columns);
    if(key === 'all') this.filteredColumns = this.columns;
    else {
      for(let i = 0; i < this.columns.length; i++) {
        this.filteredColumns = [...this.filteredColumns, [...this.columns[i].filter(el => el.type === key)]];
      }
    }
  }

  openSlider(item: GalleryItemData, idx: number) {
    if(item.type === "video") {
      this.overlay.addComponent({component: YoutubeVideoOverlayComponent, data: {"youtube-str": item.video ?? ""}});
    } else {

      if(!this.displayService.isMobileScreenSize()) { // dont open slider on mobile because doesnt make sense
        const items: GalleryItemData[] = [];

        let counter = 0;
        while(true) {
          let isAnythingAdded = false;
          for(let i = 0; i < this.filteredColumns.length; i++) {
            if(counter < this.filteredColumns[i].length) {
              items.push(this.filteredColumns[i][counter]);
              isAnythingAdded = true;
            }
          }
          counter++;
          if(!isAnythingAdded) break;
        }

        this.overlay.addComponent({component: GallerySliderComponent, data: {items: items, offset: idx}});
      }
    }
  }
}
